import moment from "moment";
import i18n from '@/plugins/i18n';

import {
    dateFormatMoment
} from '@/configure/index'

export const clearfilters = (filter, key) => {
    switch (key) {
        case 'date':
            paramsQuery.dateRange.startDate = null;
            paramsQuery.dateRange.endDate = null;
            break;
    }
    return filter;
}

export const showTextPicker = (dateRange) => {
    if (dateRange.startDate && dateRange.endDate) {
        return moment(dateRange.startDate).format(dateFormatMoment()) + ' - ' + moment(dateRange.endDate).format(dateFormatMoment());
    } else {
        return "<span class='date-placeholder'>" + i18n.t('Date...') + "</span>";
    }
}

export const showTextPickerDeposit = (dateRange) => {
    if (dateRange.startDate && dateRange.endDate) {
        return moment(dateRange.startDate).format(dateFormatMoment()) + ' - ' + moment(dateRange.endDate).format(dateFormatMoment());
    } else {
        return "<span class='date-placeholder'>" + i18n.t('Date...') + "</span>";
    }
}

export const showTextPickerBilling = (dateRange) => {
    if (dateRange.startDate && dateRange.endDate) {
        return moment(dateRange.startDate).format(dateFormatMoment()) + ' - ' + moment(dateRange.endDate).format(dateFormatMoment());
    } else {
        return "<span class='date-placeholder'>" + i18n.t('Date...') + "</span>";
    }
}


// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/directives/Vuetable.js